import React from "react";
import { Box, Tabs, Tab, Card, useTheme } from "@mui/material";
import UserDetailsForm from "../UserDetailsForm";
import ResidentInfoForm from "../ResidentInfoForm";

const ProfileTabs = ({ tabIndex, setTabIndex, userInfo }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <Tabs
        value={tabIndex}
        onChange={(e, newIndex) => setTabIndex(newIndex)}
        variant="fullWidth"
        sx={{
          mb: 3,
          "& .MuiTabs-indicator": {
            backgroundColor: "#fff",
            height: 4,
            borderRadius: "4px",
          },
        }}
      >
        <Tab
          label="User Details"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.85rem",
            color: tabIndex === 0 ? "#fff" : "rgba(255,255,255,0.6)",
            "&:hover": { color: "#fff", opacity: 0.9 },
          }}
        />
        <Tab
          label="Resident Info"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.85rem",
            color: tabIndex === 1 ? "#fff" : "rgba(255,255,255,0.6)",
            "&:hover": { color: "#fff", opacity: 0.9 },
          }}
        />
      </Tabs>

      <Box sx={{ pt: 2 }}>
        {tabIndex === 0 && (
          <UserDetailsForm 
            userInfo={userInfo} 
          />
        )}
        {tabIndex === 1 && (
          <ResidentInfoForm 
            userInfo={userInfo} 
          />
        )}
      </Box>
    </Card>
  );
};

export default ProfileTabs;
